import { combineReducers } from "redux";
import { userReducer } from "./user/user";
import { projectsReducer } from "./projects/projects";
import { organizationReducer } from "./organization/organization";
import { toastReducer } from "./toast/toast";

const createRootReducer = () =>
  combineReducers({
    user: userReducer,
    projects: projectsReducer,
    organization: organizationReducer,
    toast: toastReducer,
  });

export default createRootReducer;
